<!-- 车辆自助进出场(云停车场) -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "userUniqCode": "wdl1231231231",
                "channelId": 2465
            },
            responseCode: {
                "data": {
                    "amount": 0,
                    "areaId": 1,
                    "channelId": 2465,
                    "code": 0,
                    "inOrOut": 1,
                    "inSelfHelpCode": "3030",
                    "isPaid": 1,
                    "isParkInOut": 1,
                    "msg": "成功",
                    "outSelfHelpCode": "4979",
                    "parkCode": "2KKN6112",
                    "parkingCode": "190429111252535764456117"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台，使得车辆自助进出场（车辆可以是无牌车，也可以是有牌车）。推荐：传递参数userUniqCode和channelId调用该接口，channelId可通过扫云车场通道二维码获取。",
                t_url: this.commonUrls.test+"selfInOutForCloudPark",
                p_url: this.commonUrls.prod+"selfInOutForCloudPark",
                precondition: "云停车场通道配置，选择支持自助开闸",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userUniqCode', info2: '是', info3: 'String', info4: '第三方所属用户的唯一编码' },
                        { info1: 'parkCodes', info2: '否', info3: 'String', info4: '停车场编号，selfHelpCode不为空时必填。","分割。例如："PRJ2EBMY,PR32HQ12,2KKN6112"' },
                        { info1: 'channelId', info2: '否', info3: 'Long', info4: '通道编号，selfHelpCode为空时必填（通道类型决定进出场，可通过扫智泊平台提供通道二维码后，返回的参数channelId字段获取）' },
                        { info1: 'selfHelpCode', info2: '否', info3: 'String', info4: '随机码，channelId为空时必填' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'inSelfHelpCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        { info1: 'outSelfHelpCode', info2: '否', info3: 'String', info4: '自助离场随机码' },
                        { info1: 'inOrOut', info2: '是', info3: 'Integer', info4: '进出类型 0：进场 1：出场' },
                        { info1: 'isParkInOut ', info2: '是', info3: 'Integer', info4: '是否整个停车场 0：否 1：是' },
                        { info1: 'isPaid', info2: '是', info3: 'Integer', info4: '是否已付费 0:否 1：是' },
                        { info1: 'channelId', info2: '是', info3: 'Long', info4: '通道编号' },
                        { info1: 'areaId', info2: '否', info3: 'Long', info4: '区域编号' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车唯一编码' },
                        { info1: 'code', info2: '是', info3: 'Integer', info4: '返回码 0：成功 1：匹配不到进场随机码 2:匹配不到离场随机码 3:未缴费 4:找不到指定的自助码 5:开闸失败 6:已存在关联的自助进场记录 7:找不到指定的停车场 8:当前通道没有车辆 9:查费失败 10:当前通道没有开启自助开闸功能' },
                        { info1: 'msg', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'amount', info2: '否', info3: 'Decimal', info4: '需缴费金额，单位：元' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号码' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/selfInOutForCloudPark.vue